import * as React from "react";
import {useState} from "react";
import {Button, Flex, Text} from "@chakra-ui/react";

type Props = {
    hasLines: boolean;
    onGenerate: () => void;
    onClear: () => void;
};

const WalkLineToolbar = ({hasLines, onGenerate, onClear}: Props) => {
    const [showClearConfirm, setShowClearConfirm] = useState(false);

    const handleClear = () => {
        onClear();
        setShowClearConfirm(false);
    };

    return (
        <Flex
            position={"absolute"}
            bottom={"16px"}
            left={"16px"}
            zIndex={4}
            gap={2}
            alignItems={"center"}
        >
            <Button
                onClick={onGenerate}
                size={"sm"}
                bg={"white"}
                color={"gray.700"}
                border={"1px solid"}
                borderColor={"#cbd5e0"}
                boxShadow={"md"}
                _hover={{bg: "gray.50", borderColor: "#a0aec0"}}
            >
                Generate walk lines
            </Button>
            {hasLines && !showClearConfirm && (
                <Button
                    onClick={() => setShowClearConfirm(true)}
                    size={"sm"}
                    bg={"white"}
                    color={"red.600"}
                    border={"1px solid"}
                    borderColor={"#cbd5e0"}
                    boxShadow={"md"}
                    _hover={{bg: "red.50", borderColor: "red.300"}}
                >
                    Clear walk lines
                </Button>
            )}
            {showClearConfirm && (
                <Flex
                    bg={"white"}
                    border={"1px solid"}
                    borderColor={"red.300"}
                    borderRadius={"md"}
                    boxShadow={"md"}
                    px={3}
                    py={1}
                    gap={2}
                    alignItems={"center"}
                >
                    <Text fontSize={"sm"} color={"red.600"} whiteSpace={"nowrap"}>
                        Delete all walk lines and waypoints?
                    </Text>
                    <Button
                        onClick={handleClear}
                        size={"xs"}
                        colorScheme={"red"}
                    >
                        Yes, clear
                    </Button>
                    <Button
                        onClick={() => setShowClearConfirm(false)}
                        size={"xs"}
                        variant={"ghost"}
                    >
                        Cancel
                    </Button>
                </Flex>
            )}
        </Flex>
    );
};

export default WalkLineToolbar;
